<script>
import BaseInput from './base.vue'

export default {
  extends: BaseInput
}
</script>
